import loadable from '@loadable/component'

export const Highlight = loadable(() => import('./Highlight'))
export const HighlightChart = loadable(() => import('./HighlightChart'))
export const HighlightImage = loadable(() => import('./HighlightImage'))
export const HighlightVideo = loadable(() => import('./HighlightVideo'))
export const Highlights = loadable(() => import('./Highlights'))
export const HighlightText = loadable(() => import('./HighlightText'))
export type { HighlightProps } from './Highlight'
export type { HighlightChartProps } from './HighlightChart'
export type { HighlightImageProps } from './HighlightImage'
export type { HighlightTextProps } from './HighlightText'
export type { HighlightVideoProps } from './HighlightVideo'
export type { HighlightsProps } from './Highlights'
